import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isPast from 'date-fns/isPast';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { CHAT_WIDTH, FOOTER_HEIGHT_MOBILE } from 'app-modules/base/constants';

const styles = (theme) => ({
  alreadyStarted: {
    backgroundColor: '#666666',
    color: 'white',
    position: 'fixed',
    borderRadius: 8,
    [theme.breakpoints.up('md')]: {
      width: CHAT_WIDTH,
      right: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '95vw',
      left: '2.5vw',
      bottom: FOOTER_HEIGHT_MOBILE,
    },
  },
  notStarted: {
    backgroundColor: 'white',
    color: 'black',
  },
  contentText: {
    color: 'inherit',
    backgroundColor: 'inherit',
  },
  titleText: {
    color: 'inherit',
    backgroundColor: 'inherit',
  },
});

class OnboardDialog extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    isVisible: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    showSignUp: PropTypes.func.isRequired,
    dialogDismissed: PropTypes.func.isRequired,
    wamEpisodeStartsOnDate: PropTypes.instanceOf(Date),
  };

  static defaultProps = {
    wamEpisodeStartsOnDate: null,
  };

  handleRulesButton = () => {
    this.props.dialogDismissed();
    window.open('http://corporate.pluto.tv/winner-and-a-movie-rules', 'Rules');
  };

  handleSignUpButton = () => {
    this.props.dialogDismissed();
    this.props.showSignUp();
  };

  handleClose = () => {
    this.props.dialogDismissed();
    this.props.onClose();
  };

  render() {
    const { classes, isVisible, wamEpisodeStartsOnDate, isAuthenticated } = this.props;
    if (!wamEpisodeStartsOnDate) {
      return null;
    }

    const episodeAlreadyStarted = isPast(wamEpisodeStartsOnDate);
    const text = episodeAlreadyStarted
      ? `Winner and a Movie is a unique interactive movie experience that let's you play
       along for a chance to win a prize.`
      : `Winner and a Movie is a unique interactive movie experience that let's you play 
      along for a chance to win a prize. Join us on this channel at ${wamEpisodeStartsOnDate} to
         play along and a chance to win.`;

    return (
      <Dialog open={isVisible} onClose={this.handleClose} hideBackdrop={episodeAlreadyStarted}>
        <DialogContent
          className={episodeAlreadyStarted ? classes.alreadyStarted : classes.notStarted}
        >
          <IconButton size="small" color="inherit" onClick={this.handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <DialogTitle className={classes.titleText}>Welcome to Winner and a Movie</DialogTitle>
          <DialogContentText className={classes.contentText}>{text}</DialogContentText>
          <DialogActions>
            <Button onClick={this.handleRulesButton} color="default">
              Rules
            </Button>
            {!isAuthenticated && (
              <Button onClick={this.handleSignUpButton} variant="contained" color="primary">
                Sign Up
              </Button>
            )}
          </DialogActions>
        </DialogContent>
      </Dialog>
    );
  }
}
export const OnboardDialogComponent = withStyles(styles)(OnboardDialog);
